export default __webpack_public_path__ + "assets/models/fc498b17fc4e191f67925c4d2cda792c.glb";